import { ReactNode, type JSX } from 'react';

import cn from 'classnames';

import styles from './Text.module.scss';

const baseClass = 'gdb-text';

export type TextSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type TextColor = 'primary' | 'secondary' | 'accent' | 'muted';
export type TextTheme = 'light' | 'dark';

export type Props = {
  children: ReactNode;
  size?: TextSize;
  color?: TextColor;
  theme?: TextTheme;
  tag?: keyof JSX.IntrinsicElements;
  className?: string;
};

export const Text = ({ children, size = 'xs', color, theme = 'light', tag: Tag = 'p', className }: Props) => {
  return (
    <Tag
      className={cn(
        styles[`${baseClass}-wrapper`],
        styles[`${baseClass}-${size}`],
        color && styles[`${baseClass}-${color}`],
        styles[`${baseClass}-${theme}`],
        styles[`${baseClass}-${Tag}`],
        className,
      )}
    >
      {children}
    </Tag>
  );
};
